import { render } from "./OrganisationAdminPage.vue?vue&type=template&id=0dcb44c3"
import script from "./OrganisationAdminPage.vue?vue&type=script&lang=js"
export * from "./OrganisationAdminPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__